export default class comprobaciones {
    isDNI(nif) {
        return (
            /^(\d{8})([A-HJ-NP-TV-Z])$/.test(nif) &&
            "TRWAGMYFPDXBNJZSQVHLCKE"[RegExp.$1 % 23] == RegExp.$2
        );
    };

    isNIE(nie) {
        var nie_prefix = nie.charAt(0);

        switch (nie_prefix) {
            case "X":
                nie_prefix = 0;
                break;
            case "Y":
                nie_prefix = 1;
                break;
            case "Z":
                nie_prefix = 2;
                break;
        }

        return this.isDNI(nie_prefix + nie.substr(1));
    };

    isCIF(cif) {
        if (!cif || cif.length !== 9) {
            return false;
        }

        var letters = ["J", "A", "B", "C", "D", "E", "F", "G", "H", "I"];
        var digits = cif.substr(1, cif.length - 2);
        var letter = cif.substr(0, 1);
        var control = cif.substr(cif.length - 1);
        var sum = 0;
        var i;
        var digit;

        if (!letter.match(/[A-Z]/)) {
            return false;
        }

        for (i = 0; i < digits.length; ++i) {
            digit = parseInt(digits[i]);

            if (isNaN(digit)) {
                return false;
            }

            if (i % 2 === 0) {
                digit *= 2;
                if (digit > 9) {
                    digit = parseInt(digit / 10) + (digit % 10);
                }

                sum += digit;
            } else {
                sum += digit;
            }
        }

        sum %= 10;
        if (sum !== 0) {
            digit = 10 - sum;
        } else {
            digit = sum;
        }

        if (letter.match(/[ABEH]/)) {
            return String(digit) === control;
        }
        if (letter.match(/[NPQRSW]/)) {
            return letters[digit] === control;
        }

        return String(digit) === control || letters[digit] === control;
    };

    isTR(tr) {
        if ((tr.length != 10) && (tr.length != 9)) return false;
        if ((tr.charAt(0).toUpperCase() != "X") && (tr.charAt(0).toUpperCase() != "Y") && (tr.charAt(0).toUpperCase() != "Z")) return false;

        var leftNum = '0';
        if (tr.charAt(0).toUpperCase() == "Y") leftNum = '1';

        if (tr.length == 9) {
            return isDNI(leftNum + tr.substring(1, tr.length));
        } else {
            return isDNI(tr.substring(1, tr.length));
        }
    };

    isPassport(passport) {

        return (
            /^[a-z]{3}[0-9]{6}[a-z]?$/i.test(passport) 
        );
    }



}